// extracted by mini-css-extract-plugin
export default {"header":"VilleOnlyHeader_header__iXe0Y","logo":"VilleOnlyHeader_logo__b1qgh"};